import { Helmet } from 'react-helmet-async';

export const DefaultMeta = () => {
  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Prism" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:image" content="/webclip.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@aurouslabs" />
      <meta name="twitter:creator" content="@aurouslabs" />
      <meta name="twitter:image" content="/webclip.png" />

      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <meta name="theme-color" content="#000000" />
    </Helmet>
  );
};
